import { mainPostAListingRoute } from 'modules/main/main.routes';

import { PostOnIdealistDropdownData } from './PostOnIdealistDropdownData';

export const postOnIdealistDropdownDataEn: PostOnIdealistDropdownData = {
  triggerText: 'Post on Idealist',
  triggerHref: mainPostAListingRoute.with({}),
  search: {
    title: 'Post',
    items: [
      {
        type: 'post-a-listing',
        title: 'Post a Listing',
        href: mainPostAListingRoute.with({}),
      },
      {
        type: 'create-org',
        title: 'Add your Organization',
        href: '/organizations/create',
      },
      {
        type: 'create-community-group',
        title: 'Add your Community Group',
        href: '/organizations/create',
      },
    ],
  },
  resources: {
    title: 'Resources',
    items: [
      {
        image: 'illustrations/gear-illustration.svg',
        title: 'Employer Resources',
        description:
          'Tools and advice to help you achieve your hiring and retention goals.',
        href: '/en/orgs/resources',
      },
      {
        image: 'illustrations/talk-illustration.svg',
        title: 'Help Desk',
        description:
          'We’re here to help you with any and all of your idealist.org questions!',
        href: '/en/help',
      },
    ],
  },
};
